module.exports = __webpack_public_path__ + "img/ManekiGames_Big-lucky.c33e495b.png";